'use client';

import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/server';
import { useCallback, useEffect, useRef } from 'react';
function useResetFieldOnMethodChange(currentMethod) {
  const $ = _c(4);
  const eleRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ele => {
      eleRef.current = ele;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onReady = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!eleRef.current) {
        return;
      }
      eleRef.current.clear();
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentMethod) {
    t2 = [currentMethod];
    $[2] = currentMethod;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  return onReady;
}
export default useResetFieldOnMethodChange;